import { type VK, type KK, type DVK, type DefineDevice, VirtualIrokFe87V2, VirtualMer68SESelfDev } from './define'
import { keys } from './define_keys'

const mer68SESelfDevVKToKK = new Map<VK, KK>([
  [0x1b as VK, 0x00 as KK],
  [0x31 as VK, 0x01 as KK],
  [0x32 as VK, 0x02 as KK],
  [0x33 as VK, 0x03 as KK],
  [0x34 as VK, 0x04 as KK],
  [0x35 as VK, 0x05 as KK],
  [0x36 as VK, 0x06 as KK],
  [0x37 as VK, 0x07 as KK],
  [0x38 as VK, 0x08 as KK],
  [0x39 as VK, 0x09 as KK],
  [0x30 as VK, 0x0a as KK],
  [0xbd as VK, 0x0b as KK],
  [0xbb as VK, 0x0c as KK],
  [0x08 as VK, 0x0d as KK],
  [0x2d as VK, 0x0e as KK],
  [0x09 as VK, 0x0f as KK],
  [0x51 as VK, 0x10 as KK],
  [0x57 as VK, 0x11 as KK],
  [0x45 as VK, 0x12 as KK],
  [0x52 as VK, 0x13 as KK],
  [0x54 as VK, 0x14 as KK],
  [0x59 as VK, 0x15 as KK],
  [0x55 as VK, 0x16 as KK],
  [0x49 as VK, 0x17 as KK],
  [0x4f as VK, 0x18 as KK],
  [0x50 as VK, 0x19 as KK],
  [0xdb as VK, 0x1a as KK],
  [0xdd as VK, 0x1b as KK],
  [0xdc as VK, 0x1c as KK],
  [0x2e as VK, 0x1d as KK],
  [0x14 as VK, 0x1e as KK],
  [0x41 as VK, 0x1f as KK],
  [0x53 as VK, 0x20 as KK],
  [0x44 as VK, 0x21 as KK],
  [0x46 as VK, 0x22 as KK],
  [0x47 as VK, 0x23 as KK],
  [0x48 as VK, 0x24 as KK],
  [0x4a as VK, 0x25 as KK],
  [0x4b as VK, 0x26 as KK],
  [0x4c as VK, 0x27 as KK],
  [0xba as VK, 0x28 as KK],
  [0xde as VK, 0x29 as KK],
  [0x0d as VK, 0x2a as KK],
  [0x21 as VK, 0x2b as KK],
  [0xa0 as VK, 0x2d as KK],
  [0x5a as VK, 0x2e as KK],
  [0x58 as VK, 0x2f as KK],
  [0x43 as VK, 0x30 as KK],
  [0x56 as VK, 0x31 as KK],
  [0x42 as VK, 0x32 as KK],
  [0x4e as VK, 0x33 as KK],
  [0x4d as VK, 0x34 as KK],
  [0xbc as VK, 0x35 as KK],
  [0xbe as VK, 0x36 as KK],
  [0xbf as VK, 0x37 as KK],
  [0xa1 as VK, 0x38 as KK],
  [0x26 as VK, 0x39 as KK],
  [0x22 as VK, 0x3a as KK],
  [0xa2 as VK, 0x3c as KK],
  [0x5b as VK, 0x3d as KK],
  [0xa4 as VK, 0x3e as KK],
  [0x20 as VK, 0x41 as KK],
  [0xa5 as VK, 0x44 as KK],
  [250 as VK, 0x45 as KK],
  [0xa3 as VK, 0x46 as KK],
  [0x25 as VK, 0x47 as KK],
  [0x28 as VK, 0x48 as KK],
  [0x27 as VK, 0x49 as KK],
])

const mer68SESelfDevKKToVK = new Map<KK, VK>(Array.from(mer68SESelfDevVKToKK.entries()).map(([vk, kk]) => [kk, vk]))

const isMer68SESelfDev = (device: DefineDevice) => device === VirtualMer68SESelfDev

const getKeyDefine = (vk: VK) => keys.find((item) => item.VirtualKey === vk)

export function HIDFromVk(vk: VK): VK | undefined {
  const key = getKeyDefine(vk)
  if (key) {
    return key.HID
  }
}

export function VKFromHID(hid: number): VK | undefined {
  const key = keys.find((item) => item.HID === hid)
  return key?.VirtualKey
}

export function DVKFromVK(vk: VK, device: DefineDevice, expected?: 'vk' | 'hid'): DVK {
  const key = getKeyDefine(vk)
  if (key) {
    if (key.DVKs.get(device)) {
      return key.DVKs.get(device) as VK
    }
    if (isMer68SESelfDev(device) && key.DVKs.get(VirtualIrokFe87V2)) {
      return key.DVKs.get(VirtualIrokFe87V2) as VK
    }
    if (expected == 'hid') {
      return key.HID
    } else if (expected == 'vk') {
      return vk
    }
  }
  throw new Error('DVKFromVK Not found:' + vk)
}

export function GetDevicesEnbleKeys(device: DefineDevice): Map<KK, VK> {
  if (isMer68SESelfDev(device)) {
    const res = new Map<KK, VK>()
    mer68SESelfDevKKToVK.forEach((vk, kk) => {
      const key = getKeyDefine(vk)
      if (key && !key.Disable) {
        res.set(kk, vk)
      }
    })
    return res
  }
  const res: Map<KK, VK> = new Map<KK, VK>()
  for (const value of keys) {
    if (value.Keys.get(device) && !value.Disable) {
      const kv = value.Keys.get(device) as KK
      res.set(kv, value.VirtualKey)
    }
  }
  return res
}

export function GetDevicesDefineKeys(device: DefineDevice): Map<KK, VK> {
  if (isMer68SESelfDev(device)) {
    return new Map(mer68SESelfDevKKToVK)
  }
  const res: Map<KK, VK> = new Map<KK, VK>()
  for (const kk of keys) {
    if (kk.Keys.has(device)) {
      const kv = kk.Keys.get(device) as KK
      res.set(kv, kk.VirtualKey)
    }
  }
  return res
}

export function allKeysForDevice(device: DefineDevice): KK[] {
  if (isMer68SESelfDev(device)) {
    return Array.from(mer68SESelfDevKKToVK.keys())
  }
  const res: KK[] = []
  for (const kk of keys) {
    if (kk.Keys.has(device)) {
      const kv = kk.Keys.get(device) as KK
      res.push(kv)
    }
  }
  return res
}

export function DeviceDVKFromKK(kkValue: KK, device: DefineDevice): DVK {
  if (isMer68SESelfDev(device)) {
    const vk = mer68SESelfDevKKToVK.get(kkValue)
    if (vk !== undefined) {
      return DVKFromVK(vk, device)
    }
  }
  const data = keys.find((k) => k.Keys.get(device) == kkValue)
  if (data !== undefined) {
    return (data.DVKs.get(device) || data.DVKs.get(VirtualIrokFe87V2)) as DVK
  } else {
    throw new Error('DeviceDVKFromKK Not found:' + kkValue)
  }
}

export function HidFromKK(kkValue: KK, device: DefineDevice): VK {
  if (isMer68SESelfDev(device)) {
    const vk = mer68SESelfDevKKToVK.get(kkValue)
    if (vk !== undefined) {
      return HIDFromVk(vk) as VK
    }
  }
  const data = keys.find((k) => k.Keys.get(device) == kkValue)
  if (data !== undefined) {
    return data.HID as VK
  } else {
    throw new Error('HidFromKK Not found:' + kkValue)
  }
}

export const KeyDefineFromVK = (key: VK) => {
  const data = getKeyDefine(key)
  if (data !== undefined) {
    return data
  } else {
    throw new Error('KeyDefineFromVK Not found:' + key)
  }
}

export const kkFromVK = (key: VK, device: DefineDevice) => {
  if (isMer68SESelfDev(device)) {
    return mer68SESelfDevVKToKK.get(key)
  }
  const data = getKeyDefine(key)
  if (data !== undefined) {
    if (data.Keys.get(device) != undefined) {
      return data.Keys.get(device) as KK
    }
    return undefined
  }
  throw new Error('kkFromVK Not found:' + key)
}

export const vkFromKK = (key: KK, device: DefineDevice) => {
  if (isMer68SESelfDev(device)) {
    const vk = mer68SESelfDevKKToVK.get(key)
    if (vk !== undefined) {
      return vk
    }
  }
  const data = keys.find((k) => k.Keys.get(device) === key)
  if (data !== undefined) {
    return data.VirtualKey
  }
  throw new Error('vkFromKK Not found:' + key)
}
